import { formatApiError } from '@/api/errors'
import { mensagemDeAtendimento } from '@/components/chamados/AtendidoPor'

const PREFIXO_DO_FORMULARIO = 'custom_fields_invalid:'

const CODIGOS: Record<string, string> = {
  evidence_required: 'Esta categoria exige anexar evidência ao chamado.',
}

/**
 * A frase que o Novo Chamado mostra quando a API recusa a criação (TASK-10833).
 *
 * A tela mostrava `Erro: ${err.message}`, que é "Request failed with status code 400", e
 * jogava fora o `detail` — onde vinham os campos obrigatórios da categoria que faltaram.
 */
export function mensagemDoErroDeCriacao(err: unknown): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } } | null)?.response?.data?.detail
  const atendimento = mensagemDeAtendimento(detail)
  if (atendimento) return atendimento
  if (typeof detail === 'string') {
    if (detail.startsWith(PREFIXO_DO_FORMULARIO)) {
      return `Corrija o formulário: ${detail.slice(PREFIXO_DO_FORMULARIO.length).trim()}.`
    }
    if (CODIGOS[detail]) return CODIGOS[detail]
  }
  return formatApiError(err, 'Falha ao criar o chamado.')
}
